import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
export default function CreateProjectIntro() {
  const { t } = useTranslation();
  return (
    <>
      <Box>
        <Typography variant="h5">
          {t("introductions.createProject.header")}
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="body1">
          {t("introductions.createProject.text1")}
        </Typography>
      </Box>
    </>
  );
}
